import { z } from 'zod';

/** Quelle eines Projekt-Anhangs (MB-A). */
export const AttachmentSourceSchema = z.enum(['upload', 'salesforce']);
export type AttachmentSource = z.infer<typeof AttachmentSourceSchema>;

/** Antwort-Shape für einen Projekt-Anhang (project_attachments-Zeile). */
export const ProjectAttachmentSchema = z.object({
  attachment_id: z.string().uuid(),
  project_id: z.string().uuid(),
  file_name: z.string(),
  mime_type: z.string(),
  size_bytes: z.number().int().nonnegative(),
  source: AttachmentSourceSchema,
  sf_content_version_id: z.string().nullable(),
  sf_content_document_id: z.string().nullable(),
  created_at: z.string(),
  created_by: z.string().uuid().nullable(),
});
export type ProjectAttachment = z.infer<typeof ProjectAttachmentSchema>;

/** Eintrag der Salesforce-Datei-Liste (vor Import). */
export const SfFileListItemSchema = z.object({
  content_version_id: z.string(),
  content_document_id: z.string().nullable(),
  name: z.string(),
  type: z.string(),
  size_bytes: z.number().int().nonnegative(),
  already_imported: z.boolean(),
});
export type SfFileListItem = z.infer<typeof SfFileListItemSchema>;

/** Request-Body für den SF-File-Import. */
export const SfFileImportInputSchema = z.object({
  content_version_ids: z.array(z.string().min(1)).min(1),
});
export type SfFileImportInput = z.infer<typeof SfFileImportInputSchema>;
